import { render } from "./PopupSkeleton.vue?vue&type=template&id=0033bc20&scoped=true"
import script from "./PopupSkeleton.vue?vue&type=script&lang=js"
export * from "./PopupSkeleton.vue?vue&type=script&lang=js"

import "./PopupSkeleton.vue?vue&type=style&index=0&id=0033bc20&scoped=true&lang=scss"

import exportComponent from "/builds/dobro/amway-calculator-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0033bc20"]])

export default __exports__